import { render, staticRenderFns } from "./CreatePhoneCertificate.vue?vue&type=template&id=653c6b29&scoped=true&"
import script from "./CreatePhoneCertificate.vue?vue&type=script&lang=js&"
export * from "./CreatePhoneCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CreatePhoneCertificate.vue?vue&type=style&index=0&id=653c6b29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c6b29",
  null
  
)

export default component.exports